import { render, staticRenderFns } from "./AccountProfile.vue?vue&type=template&id=08b5792f&scoped=true&"
import script from "./AccountProfile.vue?vue&type=script&lang=js&"
export * from "./AccountProfile.vue?vue&type=script&lang=js&"
import style0 from "./AccountProfile.vue?vue&type=style&index=0&id=08b5792f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b5792f",
  null
  
)

export default component.exports